import languageEn from './en.json';
import languageKo from './ko.json';

// init translations
const translations = function (Vue) {
  Vue.i18n.add('en', languageEn);
  Vue.i18n.add('ko', languageKo);

  Vue.i18n.fallback('en'); // default language code

  Vue.i18n.set(navigator.language.split('-')[0]);
};

export default translations;
